import { render, staticRenderFns } from "./WorkplacesBar.vue?vue&type=template&id=134a3838&"
import script from "./WorkplacesBar.vue?vue&type=script&lang=js&"
export * from "./WorkplacesBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports